import cloud1 from "../../public/images/404/8-bit-cloud-1.svg";
import cloud2 from "../../public/images/404/8-bit-cloud-2.svg";
import cloud3 from "../../public/images/404/8-bit-cloud-3.svg";
import cloud4 from "../../public/images/404/8-bit-cloud-4.svg";
import finishLine from "../../public/images/404/8-bit-finish-line.svg";
import horse1 from "../../public/images/404/8-bit-horse-sprite-1.svg";
import horse2 from "../../public/images/404/8-bit-horse-sprite-2.svg";
import horse3 from "../../public/images/404/8-bit-horse-sprite-3.svg";
import horse4 from "../../public/images/404/8-bit-horse-sprite-4.svg";
import horse5 from "../../public/images/404/8-bit-horse-sprite-5.svg";
import { Link } from "react-router-dom";
import OpenIntercomLink from "../components/open-intercom-link";
import pure from "../components/higher-order/pure";
import React from "react";
import startingGate from "../../public/images/404/8-bit-starting-gate.svg";

export default pure(function Error404() {
  return (
    <div>
      <div className="l-row">
        <div className="l-wrapper">
          <div className="l-content l-content--80-percent text-center">
            <h1>
              404: Page Not Found
            </h1>

            <h2>
              Sorry! The requested page doesn&apos;t exist or has been scratched.
            </h2>

            <p>
              <OpenIntercomLink className="btn btn--transparent margin-bottom--is-10-mobile">
                Contact Support
              </OpenIntercomLink>

              <Link className="btn btn--primary margin-bottom--is-10-mobile" to="/tournaments">
                Browse Tournaments
              </Link>
            </p>
          </div>
        </div>
      </div>

      <div className="horse-race">
        <img className="horse-race_starting-gate" src={startingGate} />

        <img className="horse-race_cloud-1" src={cloud1} />

        <img className="horse-race_cloud-2" src={cloud2} />

        <img className="horse-race_cloud-3" src={cloud3} />

        <img className="horse-race_cloud-4" src={cloud4} />

        <div className="horse-race_horse-item horse-race_horse-item--1">
          <img className="horse-race_horse-image" src={horse1} />
        </div>

        <div className="horse-race_horse-item horse-race_horse-item--2">
          <img className="horse-race_horse-image" src={horse2} />
        </div>

        <div className="horse-race_horse-item horse-race_horse-item--3">
          <img className="horse-race_horse-image" src={horse3} />
        </div>

        <div className="horse-race_horse-item horse-race_horse-item--4">
          <img className="horse-race_horse-image" src={horse4} />
        </div>

        <div className="horse-race_horse-item horse-race_horse-item--5">
          <img className="horse-race_horse-image" src={horse5} />
        </div>

        <img className="horse-race_finish-line" src={finishLine} />
      </div>
    </div>
  );
});
